import styled from "styled-components";

const Styles = styled.div`
  & .ant-btn[class*="status-"] {
    padding: 0;
    border: 0;
    background: transparent;

    &:hover span {
      text-decoration: underline;
    }
    &[ant-click-animating-without-extra-node="true"]::after {
      display: none;
    }
  }

  & .status-inUse {
    color: #1a65bc;
  }
  & .status-expire {
    color: #aab1bf;
  }
  & .status-cancle {
    color: #ef5d5d;
  }
`;

export default Styles;
